import types from '../constants/actionTypes';
import { LIST_VIEW, GRID_VIEW } from '../constants/viewTypes';

const viewState = (state, action) => {
  switch (action.type) {
    case types.view.TOGGLE_ACTIVE_VIEW:
      if (state.get(action.view) === LIST_VIEW) {
        state = state.set(action.view, GRID_VIEW);
      } else {
        state = state.set(action.view, LIST_VIEW);
      }

      break;
    case types.view.REQUEST_TAB_CHANGE:
      state = state.set('tab', action.value);
      break;

    case types.view.INCREMENT_PAGE:
      // console.log('INCREMENT_PAGE', state.get('action').get('view').get('hitsPerPge'))
      state = state.set('hitsPerPage', state.get('hitsPerPage') + action.value)
      break;
  }
  return state;
};

export default viewState;


export function incrementPage(incrementValue) {
  return {
    type: types.view.INCREMENT_PAGE,
    type: types.view.INCREMENT_PAGE,
    value: incrementValue,
  }
}


/** WEBPACK FOOTER **
 ** ./reducers/viewState.js
 **/